import { useEffect, useState } from 'react'

export const useMapZoom = (map: google.maps.Map | null | undefined): number => {
  const [zoom, setZoom] = useState(() => map?.getZoom() ?? 0)

  useEffect(() => {
    if (!map) return
    setZoom(map.getZoom() ?? 0)

    const listener = map.addListener('zoom_changed', () => {
      setZoom(map.getZoom() ?? 0)
    })

    return () => listener.remove()
  }, [map])

  return zoom
}
